import { Component } from "./Component";
import { vp } from "../managers/vp";
export class NavList extends Component {
    constructor() {
        super(...arguments);
        this._startIndex = 0;
    }
    init() {
        const stringStartIndex = this.html.parentElement.getAttribute("data-start-index");
        this._startIndex = parseInt(stringStartIndex ? stringStartIndex : "0");
        console.log(this._startIndex);
    }
    get scrollTop() {
        return this.html.scrollTop;
    }
    set scrollTop(value) {
        this._scrollTopForLoad = value;
    }
    onAllComplete() {
        const currentItemID = vp.localStorageData.menu.current;
        let foundCurrent = false;
        let index = 0;
        this.forEachComponent('NavListItem', (item) => {
            if (!foundCurrent) {
                if (currentItemID > -1) {
                    item.isCurrentPage = currentItemID === item.id;
                }
                else {
                    item.isCurrentPage = item.isCurrentUrl;
                }
                if (item.isCurrentPage) {
                    foundCurrent = true;
                }
            }
        });
        this.forEachComponent('NavListItem', (item) => {
            item.onNavListComplete();
            if (index < this._startIndex) {
                console.log(item.html);
                item.html.hidden = true;
            }
            if (item.getWasPreviouslyOpened() || item.hasCurrentPageItem()) {
                item.openList();
            }
            this.html.style.visibility = 'visible';
            index++;
        });
        this.scrollToLastPos();
        vp.localStorageData.menu.current = -1;
    }
    scrollToLastPos() {
        setTimeout(() => {
            log('scroll', this._scrollTopForLoad);
            this.html.scrollTop = this._scrollTopForLoad;
        }, 100);
    }
    update() {
        this.scrollToLastPos();
        this.forEachComponent('NavListItem', (item) => {
            item.updateList();
        });
    }
}
